



























import { Component, Vue, Watch } from "vue-property-decorator";
import YcHeader from "@/components/common/yc-header.vue";
import YcAside from "@/components/common/yc-aside.vue";

interface paneitem {
  label: string;
  value: string;
}
const GreetingProps = Vue.extend({
  props: {
    flowDetailObj: Object
  }
})
@Component({
  components: {
    "yc-aside": YcAside,
    "yc-header": YcHeader,
  },
})
export default class wheelOfFortuneList extends GreetingProps {
  public flowDetail: {label:string,value:string,count?:number}[] = [];

  created(): void {
    this.flowDetail = this.$route.query.strategyChannel === 'Sms'? [
      {label :this.$tx('campaign.stats.entered', '进入数'),value :'-'},
      {label :this.$tx('campaign.stats.filtered2', '过滤数'),value :'-'},
      {label :this.$tx('campaign.stats.waiting', '等待数'),value :'-'},
      {label :this.$tx('campaign.stats.sent', '已发送'),value :'-'},
      {label :this.$tx('campaign.list.col.deliveryRate', '送达率'),value :'-',count:0},
      {label :this.$tx('campaign.stats.clickRate2', '点击率'),value :'-',count:0},
      {label :this.$tx('campaign.stats.fromCartseeOrders', '来自cartsee订单数'),value :'-'},
      {label :this.$tx('campaign.stats.fromCartseeSales', '来自cartsee销售额'),value :'-'},
      {label :this.$tx('campaign.stats.conversionRate', '转化率'),value :'-'},
      {label :this.$tx('campaign.stats.avgOrderValue', '客单价'),value :'-'},
      {label :this.$tx('campaign.list.col.bounce', '退回率'),value :'-',count:0},
      {label :this.$tx('campaign.list.col.unsubscribe', '退订率'),value :'-',count:0},
    ]:[
      {label :this.$tx('campaign.stats.entered', '进入数'),value :'-'},
      {label :this.$tx('campaign.stats.filtered2', '过滤数'),value :'-'},
      {label :this.$tx('campaign.stats.waiting', '等待数'),value :'-'},
      {label :this.$tx('campaign.stats.sent', '已发送'),value :'-'},
      {label :this.$tx('campaign.list.col.deliveryRate', '送达率'),value :'-',count:0},
      {label :this.$tx('campaign.stats.openRate', '打开率'),value :'-',count:0},
      {label :this.$tx('campaign.stats.clickRate2', '点击率'),value :'-',count:0},
      {label :this.$tx('campaign.stats.fromCartseeOrders', '来自cartsee订单数'),value :'-'},
      {label :this.$tx('campaign.stats.fromCartseeSales', '来自cartsee销售额'),value :'-'},
      {label :this.$tx('campaign.stats.conversionRate', '转化率'),value :'-'},
      {label :this.$tx('campaign.stats.avgOrderValue', '客单价'),value :'-'},
      {label :this.$tx('campaign.list.col.bounce', '退回率'),value :'-',count:0},
      {label :this.$tx('campaign.list.col.complaint', '投诉率'),value :'-',count:0},
      {label :this.$tx('campaign.list.col.unsubscribe', '退订率'),value :'-',count:0},
    ]
    // this.getWheelOfFortuneList();
  }

  getclass(scope:any){return '__status--' + { 0:'suspend',1 :'running'}[scope.row.status as 1 | 0]}

  //显示空值
  formatterChangeNUll(r:any, c:any, v:any){return  v === 0?'$0':(`$${v}` || '-')}

  formatterChange(r:any, c:any, v:any) {return v === 0?0:(v || '-')}

  sortChange(){}
  @Watch("flowDetailObj")
  changFlowDetailObj(oldval: any, newval: any){
    newval = this.$props.flowDetailObj
    if (this.$route.query.strategyChannel === 'Sms') {
      this.flowDetail = [
        {label :this.$tx('campaign.stats.entered', '进入数'),value :newval.enterCount},
        {label :this.$tx('campaign.stats.filtered2', '过滤数'),value :newval.filterCount},
        {label :this.$tx('campaign.stats.waiting', '等待数'),value :newval.waitCount},
        {label :this.$tx('campaign.stats.sent', '已发送'),value :newval.sendCount},
        {label :this.$tx('campaign.list.col.deliveryRate', '送达率'),value :newval.deliveryRate,count:newval.deliveryCount},
        {label :this.$tx('campaign.stats.clickRate2', '点击率'),value :newval.clickRate ,count:newval.clickCount},
        {label :this.$tx('campaign.stats.fromCartseeOrders', '来自cartsee订单数'),value :newval.totalOrderCount },
        {label :this.$tx('campaign.stats.fromCartseeSales', '来自cartsee销售额'),value :newval.totalOrderAmount },
        {label :this.$tx('campaign.stats.conversionRate', '转化率'),value : newval.convertRate },
        {label :this.$tx('campaign.stats.avgOrderValue', '客单价'),value : newval.singlePrice},
        {label :this.$tx('campaign.list.col.bounce', '退回率'),value :newval.bounceRate ,count:newval.bounceCount},
        {label :this.$tx('campaign.list.col.unsubscribe', '退订率'),value :newval.unsubscribeRate ,count:newval.unsubscribeCount},
      ]
    } else {
      this.flowDetail = [
        {label :this.$tx('campaign.stats.entered', '进入数'),value :newval.enterCount},
        {label :this.$tx('campaign.stats.filtered2', '过滤数'),value :newval.filterCount},
        {label :this.$tx('campaign.stats.waiting', '等待数'),value :newval.waitCount},
        {label :this.$tx('campaign.stats.sent', '已发送'),value :newval.sendCount},
        {label :this.$tx('campaign.list.col.deliveryRate', '送达率'),value :newval.deliveryRate,count:newval.deliveryCount},
        {label :this.$tx('campaign.stats.openRate', '打开率'),value :newval.openRate ,count:newval.openCount},
        {label :this.$tx('campaign.stats.clickRate2', '点击率'),value :newval.clickRate ,count:newval.clickCount},
        {label :this.$tx('campaign.stats.fromCartseeOrders', '来自cartsee订单数'),value :newval.totalOrderCount },
        {label :this.$tx('campaign.stats.fromCartseeSales', '来自cartsee销售额'),value :newval.totalOrderAmount },
        {label :this.$tx('campaign.stats.conversionRate', '转化率'),value : newval.convertRate },
        {label :this.$tx('campaign.stats.avgOrderValue', '客单价'),value : newval.singlePrice},
        {label :this.$tx('campaign.list.col.bounce', '退回率'),value :newval.bounceRate ,count:newval.bounceCount},
        {label :this.$tx('campaign.list.col.complaint', '投诉率'),value :newval.complaintRate ,count:newval.complaintCount},
        {label :this.$tx('campaign.list.col.unsubscribe', '退订率'),value :newval.unsubscribeRate ,count:newval.unsubscribeCount},
      ]
    }

  }
}
